import PropTypes from 'prop-types';
import React from 'react';
import ResponsiveImage from './ResponsiveImage';
import { BsBadge3D } from 'react-icons/bs';

const Product3DModelThumbnail = ({ index, model, onClick }) => {
    const onClickHandler = () => {
        onClick(index);
    };
    return (
        <button
            className={'product-gallery--thumbnail-button position-relative'}
            onClick={onClickHandler}
        >
            <BsBadge3D
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    fontSize: '30px',
                    background: 'rgba(37, 37, 37, 0.2)',
                    padding: '5px',
                    boxSizing: 'content-box',
                }}
                color={'white'}
            />
            <ResponsiveImage
                imageUrl={model.posterUrl}
                mobileSize={'75px'}
                desktopSize={'75px'}
            />
        </button>
    );
};

Product3DModelThumbnail.propTypes = {
    model: PropTypes.object,
    onClick: PropTypes.func,
    index: PropTypes.number
};



export default Product3DModelThumbnail;